<template>
  <button
    :disabled="disabled"
    @click="$emit('click')"
    :style="{
      cursor: disabled ? 'not-allowed' : 'pointer',
      'background-color': isActive ? '#38a169' : 'transparent',
      color: isActive ? 'white' : 'black',
      border: '1px solid #ccc',
      'border-radius': '5px',
      padding: '0.5rem 1rem',
      margin: '0 0.25rem',
    }"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'PaginationButton',
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click']
}
</script> 